import { render } from "./property_top.vue?vue&type=template&id=63d2fb54&scoped=true"
import script from "./property_top.vue?vue&type=script&lang=js"
export * from "./property_top.vue?vue&type=script&lang=js"

import "./property_top.vue?vue&type=style&index=0&id=63d2fb54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d2fb54"]])

export default __exports__